<template>
    <div v-if="reviews" class="mb-12">
        <img v-if="reviewType==='tripadvisor'" class="w-44 lg:w-auto mb-6" width="302" height="64" :src="tripadvisorLogoUrl" alt="tripadvisor logo" loading="lazy">
        
        <img v-if="reviewType==='google'" class="w-11 lg:w-auto mb-6" width="64" height="64" :src="googleLogoUrl" alt="google logo" loading="lazy">

        <Splide :has-track="false" class="relative" :options="options">
            <SplideTrack :class="{ 'experience-reviews-height': isExperiencePage }">
                <SplideSlide :key="item.id" v-for="item in reviews" class="flex items-start">
                    <ReviewsItem
                        :item="item"
                    />
                </SplideSlide>
            </SplideTrack>

            <div class="splide__arrows absolute -bottom-12 left-0 flex justify-between w-full lg:w-auto gap-2">
                <button class="splide__arrow--prev w-11 h-11 flex justify-center items-center bg-primary hover:bg-primary-tone rounded-full">
                    <svg class="relative -left-px" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" fill="#3B3C4A"/>
                    </svg>
                </button>

                <button class="splide__arrow--next w-11 h-11 flex justify-center items-center bg-primary hover:bg-primary-tone rounded-full">
                    <svg class="relative -right-px" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" fill="#3B3C4A"/>
                    </svg>
                </button>
            </div>
        </Splide>
    </div>
</template>
<script>
import ReviewsItem from './ReviewsItem'
import {defineComponent} from 'vue'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'

export default defineComponent({
    components: {
        ReviewsItem,
        Splide,
        SplideSlide,
        SplideTrack,
    },
    data: () => ({
        themeUrl: window.storage.settings.theme_url,
        options: {
            pagination: false,
            arrows: true,
            type : 'loop',
            perMove: 1,
        },
    }),
    props: {
        reviewType: {
            type: String,
            default: "",
        },
    },
    computed: {
        tripadvisorLogoUrl() {
            return this.themeUrl + '/assets/images/tripadvisor-logo.svg'
        },
        googleLogoUrl() {
            return this.themeUrl + '/assets/images/google-logo.svg'
        },
        reviews() {
            if( this.reviewType === 'tripadvisor' ) {
                return window?.capes?.reviews_tripadvisor ?? {}
            } else if( this.reviewType === 'google' ) {
                return window?.capes?.reviews_google ?? {}
            }
        },
        isExperiencePage() {
            // Check if we're on an experience page by looking at the URL or page type
            return window.location.pathname.includes('/visit-experiences/') || 
                   document.body.classList.contains('page-template-experience');
        },
    },
});
</script>

<style scoped>
/* Only apply on desktop (lg breakpoint and up) and only on experience pages */
@media (min-width: 1024px) {
    .experience-reviews-height {
        height: 70%;
    }
}
</style>